import { render } from "./Releases.vue?vue&type=template&id=abe00a12&scoped=true"
import script from "./Releases.vue?vue&type=script&lang=js"
export * from "./Releases.vue?vue&type=script&lang=js"

import "./Releases.vue?vue&type=style&index=0&id=abe00a12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe00a12"]])

export default __exports__